import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import CustomRoute from "./components/CustomRoute";
import SocketProvider from "./context/socketContext";
import Login from "./pages/Login";
import Home from "./pages/Home";

// Licenses
import Licenses from "./pages/Licenses";
import Devices from "./pages/Licenses/devices/index";

// Manage Sessions
import Sessions from "./pages/ManageSessions";
import PastSessionPage from "./pages/ManageSessions/past_session_page";
import SessionForm from "./pages/ManageSessions/session_form/session_form";

// Manage Groups
import Groups from "./pages/ManageGroups";
import GroupForm from "./pages/ManageGroups/group_form/group_form";

// Manage Courses
import Courses from "./pages/ManageCourses";
import CourseForm from "./pages/ManageCourses/course_form/course_form";

// Manage Users
import Users from "./pages/ManageUsers";
import RolesAndPermissions from "./pages/ManageUsers/roles_permissions/roles_permissions";
import RoleForm from "./pages/ManageUsers/roles_permissions/role_form/role_form";
import UserForm from "./pages/ManageUsers/user_form/UserForm";

//Reports
import Reports from "./pages/Reports";
import Details from "./pages/Reports/details/details";
import SessionDetails from "./pages/Reports/session_details/SessionDetails";

// Settings
import Settings from "./pages/Settings";

// Profile
import Profile from "./pages/Profile";
import IframeAvatar from "./pages/Profile/iframe_avatar/iframe_avatar";

// Terms and Conditions
import TermsOfService from "./pages/TermsOfService";

import DownloadDistool from "./pages/DownloadDisTool";
import Assets from "./pages/Assets";
import "./index.css";
import MaintenanceView from "./pages/MaintenanceView";
import HubSpotTracker from "./components/Trackers/HubSpotTracker";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import EULA from "./pages/EndUserLicenseAgreement";

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  return (
    <>
      <HubSpotTracker />
      {isLoginPage ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        <SocketProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route
              path="/home"
              element={<CustomRoute isProtected component={Home} />}
            />
            <Route path="/licenses">
              <Route
                index
                element={
                  <CustomRoute adminOnly isProtected component={Licenses} />
                }
              />
              <Route
                path="devices/:licenseId"
                element={
                  <CustomRoute adminOnly isProtected component={Devices} />
                }
              />
            </Route>
            <Route path="/manage-sessions">
              <Route
                index
                element={<CustomRoute isProtected component={Sessions} />}
              />
              <Route
                path=":previous/:idSession"
                element={
                  <CustomRoute
                    adminOnly
                    isProtected
                    component={PastSessionPage}
                  />
                }
              />
              <Route
                path="create-session"
                element={
                  <CustomRoute adminOnly isProtected component={SessionForm} />
                }
              />
              <Route
                path="edit-session/:multiplayerId"
                element={
                  <CustomRoute adminOnly isProtected component={SessionForm} />
                }
              />
            </Route>
            <Route path="/manage-groups">
              <Route
                index
                element={
                  <CustomRoute adminOnly isProtected component={Groups} />
                }
              />
              <Route
                path="create-group"
                element={
                  <CustomRoute adminOnly isProtected component={GroupForm} />
                }
              />
              <Route
                path="edit-group/:groupId"
                element={
                  <CustomRoute adminOnly isProtected component={GroupForm} />
                }
              />
            </Route>
            <Route path="/manage-courses">
              <Route
                index
                element={
                  <CustomRoute adminOnly isProtected component={Courses} />
                }
              />
              <Route
                path="create-course"
                element={
                  <CustomRoute adminOnly isProtected component={CourseForm} />
                }
              />
              <Route
                path="edit-course/:courseId"
                element={
                  <CustomRoute adminOnly isProtected component={CourseForm} />
                }
              />
            </Route>
            <Route path="/manage-users">
              <Route
                index
                element={
                  <CustomRoute adminOnly isProtected component={Users} />
                }
              />
              <Route
                path="roles-permissions"
                element={
                  <CustomRoute
                    adminOnly
                    isProtected
                    component={RolesAndPermissions}
                  />
                }
              />
              <Route
                path="create-role"
                element={
                  <CustomRoute adminOnly isProtected component={RoleForm} />
                }
              />
              <Route
                path="edit-role/:roleId"
                element={
                  <CustomRoute adminOnly isProtected component={RoleForm} />
                }
              />
              <Route
                path="create-user"
                element={
                  <CustomRoute adminOnly isProtected component={UserForm} />
                }
              />
              <Route
                path="edit-user/:userId"
                element={
                  <CustomRoute adminOnly isProtected component={UserForm} />
                }
              />
            </Route>
            <Route path="/reports">
              <Route
                index
                element={<CustomRoute isProtected component={Reports} />}
              />
              <Route
                path=":idSession"
                element={<CustomRoute isProtected component={SessionDetails} />}
              />
              <Route path="details/:username/:idProduct">
                <Route
                  index
                  element={<CustomRoute isProtected component={Details} />}
                />
                <Route
                  path=":idSession"
                  element={
                    <CustomRoute
                      adminOnly
                      isProtected
                      component={SessionDetails}
                    />
                  }
                />
              </Route>
            </Route>
            <Route path="/settings">
              <Route
                index
                element={
                  <CustomRoute adminOnly isProtected component={Settings} />
                }
              />
            </Route>
            <Route
              path="/profile"
              element={<CustomRoute isProtected component={Profile} />}
            />
            <Route
              path="/customize-avatar"
              element={<CustomRoute isProtected component={IframeAvatar} />}
            />
            <Route
              path="/terms-of-service"
              element={<CustomRoute component={TermsOfService} />}
            />
            <Route
              path="/privacy-policy"
              element={<CustomRoute component={PrivacyPolicy} />}
            />
            <Route
              path="/end-user-license-agreement"
              element={<CustomRoute component={EULA} />}
            />
            <Route
              path="/assets"
              element={<CustomRoute isProtected component={Assets} />}
            />
            <Route
              path="/404"
              element={<CustomRoute component={MaintenanceView} />}
            />
          </Routes>
        </SocketProvider>
      )}
    </>
  );
}

export default App;
